"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEnglishMessages = void 0;
var property_1 = require("@promaster-sdk/property");
var uom_1 = require("uom");
var ts_exhaustive_check_1 = require("ts-exhaustive-check");
function buildEnglishMessages(unitsFormat) {
    return {
        comparisionOperationMessage: function (op, left, right) {
            return left + " " + _comparisonOperationTypeToString(op) + " " + right;
        },
        equalsOperationMessage: function (op, left, right) {
            return left + " " + _equalsOperationTypeToString(op) + " " + right;
        },
        rangeMessage: function (min, max) {
            return "between " + min + " and " + max;
        },
        andMessage: function () {
            return "and";
        },
        orMessage: function () {
            return "or";
        },
        propertyNameMessage: function (propertyName) {
            return propertyName;
        },
        propertyValueMessage: function (propertyName, propertyValue
        // unitsFormat: {
        //   readonly [key: string]: UnitFormat.UnitFormat;
        // } = UnitsFormat
        // unitsFormat: UnitFormat.UnitFormatMap
        ) {
            switch (propertyValue.type) {
                case "amount": {
                    var unitFormat = uom_1.UnitFormat.getUnitFormat(propertyValue.value.unit, unitsFormat);
                    if (unitFormat) {
                        return propertyValue.value.value + " " + unitFormat.label;
                    }
                    else {
                        return propertyValue.value.value.toString();
                    }
                }
                case "integer":
                    // eslint-disable-next-line no-case-declarations
                    var pvString = property_1.PropertyValue.toString(propertyValue);
                    return propertyName + "_" + pvString;
                case "text":
                    return propertyValue.value;
                default:
                    return ts_exhaustive_check_1.exhaustiveCheck(propertyValue);
            }
            // return "MESSAGE NOT AVAILABLE";
        },
        nullMessage: function () {
            return "null";
        },
    };
}
exports.buildEnglishMessages = buildEnglishMessages;
function _comparisonOperationTypeToString(type) {
    switch (type) {
        case "lessOrEqual":
            return "must be less than or equal to";
        case "greaterOrEqual":
            return "must be greater than or equal to";
        case "less":
            return "must be less than";
        case "greater":
            return "must be greater than";
        default:
            throw new Error("Unknown ComparisonOperationType ");
    }
}
function _equalsOperationTypeToString(type) {
    switch (type) {
        case "equals":
            return "must be";
        case "notEquals":
            return "must not be";
        default:
            throw new Error("Unknown EqualsOperationType " + type + ".");
    }
}
//# sourceMappingURL=filter-pretty-print-messages-english.js.map